import { extractSellingPlanIntervalFromName } from 'src/functions/product/extractSellingPlanIntervalFromName'

import type { SellingPlanAllocation, SellingPlanGroup } from 'src/data/graphql-generated'
import type { ProductSubscriptionSellingPlans, SubscriptionSellingPlans } from 'src/types/Subscription'

export const subscriptionSellingPlanGenerator = (
  productSellingPlanGroups: SellingPlanGroup[],
): ProductSubscriptionSellingPlans => {
  const hasSellingPlans = Number(productSellingPlanGroups?.length) > 0

  const sellingPlans: SubscriptionSellingPlans =
    productSellingPlanGroups?.reduce((acc, current): Record<number, string> => {
      const sellingPlanName = current.name
      const key = extractSellingPlanIntervalFromName(sellingPlanName)
      const coffeeSellingPlanId = current.sellingPlans.nodes[0].id

      return { ...acc, [key]: { coffeeSellingPlanId, interval: key } }
    }, {}) || {}

  return {
    sellingPlans,
    hasSellingPlans,
  }
}

export const cartItemSellingPlanGenerator = (productSellingPlanAllocation: SellingPlanAllocation[] | []) => {
  const sellingPlanNodes = productSellingPlanAllocation
  const hasSellingPlans = Number(sellingPlanNodes?.length) > 0

  const sellingPlans: SubscriptionSellingPlans =
    sellingPlanNodes?.reduce((acc, current): Record<number, string> => {
      const sellingPlanName = current.sellingPlan.name
      const key = extractSellingPlanIntervalFromName(sellingPlanName)
      const coffeeSellingPlanId = current.sellingPlan.id

      return { ...acc, [key]: { coffeeSellingPlanId, interval: key } }
    }, {}) || {}

  return {
    sellingPlans,
    hasSellingPlans,
  }
}
